import { durationInYears } from "@/helpers/formattingHelper"

// Exported Methods
export const tariffDisplayName = (tariffName, tariff) => {
  if (isNonDD(tariffName)) {
    return tariffName.replace("Non DD", "- No Direct Debit")
  }
  if (isVariableGreen(tariff)) {
    return `${tariff.display.split("-")[0]}${tariffDurationFormatted(
      tariff.duration_months
    )}`
  } else if (!tariff.variable) {
    return tariff.display.split("-")[0].trim()
  }
  return tariffName
}

export const isNonDD = tariffName => tariffName.includes("Non DD")

// Local File Methods
const isVariableGreen = tariff => tariff.variable && tariff.duration_months

const tariffDurationFormatted = durationMonths => {
  if (durationMonths % 12 === 0) {
    return `${durationInYears(durationMonths)} Year`
  }
  return `${durationMonths} Month`
}
